import { PrintCardMenu } from './print-card-menu';
import { FONT, FontStyleSheet } from '../font-style-sheets';
import { AssetLibraryType } from '../../enum/dto/asset-library-type.enum';

export class KoanPrintCardMenu extends PrintCardMenu {
  whatFontsAreNeededToRenderContent(): FontStyleSheet[] {
    return [FONT.Montserrat.Regular_400, FONT.Montserrat.Medium_500, FONT.Montserrat.Bold_700];
  }

  override getAdobeFontFamilyCssUrl(): string | null {
    return 'https://use.typekit.net/zcc7vbk.css';
  }

  shouldFetchVariantAssets(): boolean {
    return true;
  }

  variantAssetTypeSortOrder(): string[] {
    return [AssetLibraryType.PrimaryBrand, AssetLibraryType.AlternateBrand, AssetLibraryType.Brand];
  }
}
